import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { ReportsService } from "src/app/_Reports/services/reports.service";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LosService } from "../../_LOS/services/los.service";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
declare var $: any;
import { QuickLoanService } from "../services/quickLoan.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import * as moment from "moment";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";


@Component({
  selector: 'app-quickloan-sourced-application-reports',
  templateUrl: './quickloan-sourced-application-reports.component.html',
  styleUrls: ['./quickloan-sourced-application-reports.component.scss']
})
export class QuickloanSourcedApplicationReportsComponent implements OnInit {
  showSpinner: boolean = false;
  // dataSource: any;
  FromDate: any = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  ToDate: any = new Date();
  currentUser: any;
  maxDate: any;
  minDate: any;
  BranchesList: any = [];
  ProductList: any = [];
  DataSource = new MatTableDataSource<any>();
  JsonData: any[] = [];
  JsonDataTeam: any[] = [];
  JsonProcessData: any[] = [];
  showTable: boolean = false;
  ProcessType: any;
  teamListData: any[] = [];
  processListData: any[] = [];
  displayedProcessColumns: string[] = []
  dataProcessSource: any;
  displayedTeamColumns: string[] = []
  dataTeamSource: any
  SelectBranch: any = "All";
  ProductId: any = "All";
  selectedTeam: any;
  selectedProcess: any;
  displayedOverallColumns: string[] = [
    "#",
    "Application_No",
    "LoanAcNo",
    "Sourced_On",
    "Sourced_By",
    "Completed_ON",
    "BranchName",
    "ProductName",
    "Customer_Name",
    "Current_Process",
    "Loan_Status",
    "EmployeeName",
    "PendingSince",
    "Proposed_loanAmount",
    "Approved_loanAmount",
    "TAT"
  ]

  LoanId: any;
  Remarks: any;
  Status: any = "";
  displayedDetailColumns: string[] = [];
  dataSourceDetail: MatTableDataSource<any> = new MatTableDataSource([]);
  TatReportsList: any;
  Application_No: any;
  CustomerInfo: any;
  Product: any;
  Branch: any;
  AddLoan: boolean = true;
  ApplicationCreatedOn: any;
  LoanAmount: any;
  LoanDuration_Month: any;
  @ViewChild(MatSort) sort: MatSort;
    PendingSince: any;
  ProcessComplition: any;
  dataSource: any;


  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  tab: any = "mytask";
  // @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('overallSort') overallSort: MatSort;
  @ViewChild('overallPaginator') overallPaginator: MatPaginator;

  @ViewChild('processSort') processSort: MatSort;
  @ViewChild('processPaginator') processPaginator: MatPaginator;

  @ViewChild('teamSort') teamSort: MatSort;
  @ViewChild('teamPaginator') teamPaginator: MatPaginator;
  @ViewChild('overallExporter') overallExporter: any;
  @ViewChild('teamExporter') teamExporter: any;
  @ViewChild('processExporter') processExporter: any;


  constructor(private route: ActivatedRoute,
    private dataSharingService: DataSharingService,
    private reportsService: ReportsService,
    private MasterService: MasterService,
    private losService: LosService,
    private _QuickLoanService: QuickLoanService,
    private snackBar: MatSnackBar,
    private lmsService: LmsService) {
      
     }
  
  ngOnInit(): void {
    
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Sourced Application Status");
    this.getBranchesList();
    this.getProductDropdown();
 
    this.onSearchSourcedApplicationList();
    
}
   getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }
  
  getProductDropdown() {
    this.MasterService
      .GetProductList({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.ProductList = JSON.parse(JSON.stringify(result));
        console.log("Product List", this.ProductList);
      });
  }

  applyFilter(filterValue: string) {
    this.DataSource.filter = filterValue.trim().toLowerCase();
  }
  DateChange() {
    if (this.FromDate != "" && this.ToDate != "") {
      if (this.FromDate > this.ToDate) {
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "To Date will be greater than to From Date.",
          ...this.configSuccess,
        });
        this.FromDate = "";
        this.ToDate = "";
      }
    }
  }
  changeTab(tab: any) {
    if (tab !== this.tab) {
      this.tab = tab;
      this.selectedTeam = undefined;
      this.selectedProcess = undefined;
      $(".filterInput").val("");

      if (tab === "mytask") {
        this.onSearchSourcedApplicationList();
      } else if (tab === "team") {
        this.LOS_Sourced_ApplicationStatus_Report_By_Team();
        this.getBranchesList();
      } else if (tab === "process") {
        this.LOS_Sourced_ApplicationStatus_Report_By_PROCESS();
        this.getBranchesList();
      }
      
    }
  }

  onSearchSourcedApplicationList() {
    
    this.losService
      .LOS_Sourced_ApplicationStatus_Report({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserid: this.currentUser.userId ,
        BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
        ProductId: this.ProductId == "All" ? 0 : this.ProductId,
        
      })
      .subscribe((res: any) => {
        console.log("Api call data", res);
        if (res.length > 0) {
          this.JsonData = res || [];
         this.DataSource.data = this.JsonData;
             if (this.overallPaginator) this.DataSource.paginator = this.overallPaginator;
            if (this.overallSort) this.DataSource.sort = this.overallSort;
          console.log("Data", res);
        } else {
          this.JsonData = [];
          this.DataSource.data = [];
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "No data found",
            ...this.configSuccess,
          });
          // this.DataSource = null;

        }
      });  
      this.LOS_Sourced_ApplicationStatus_Report_By_PROCESS();
      this.LOS_Sourced_ApplicationStatus_Report_By_Team();
  }
  

  LOS_Sourced_ApplicationStatus_Report_By_PROCESS() {
    this.showSpinner = true;
    this.losService.LOS_Sourced_ApplicationStatus_Report_By_PROCESS({
      FromDate: this.FromDate,
      To: this.ToDate,
      LoginUserid: this.currentUser.userId ,
      BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
      ProductId: this.ProductId == "All" ? 0 : this.ProductId,
      ManagerId: this.currentUser.userId,
      ProcessId: "0",
    }).subscribe((res: any) => {
      this.processListData = res.Item1;
      this.showSpinner = false;
    });
  }
  getDetail(item: any) {
    // Toggle logic: if same card is clicked again, collapse it
   
    // if (this.selectedProcess?.ProcessId === item.ProcessId) {
    //   this.selectedProcess = null;
    //   this.dataProcessSource = new MatTableDataSource([]);
    //   return;
    // }

    this.showSpinner = true;
    this.selectedProcess = item;
    console.log("this.selectedProcess", item);

    // console.log("this.selectedProcess", item.ProcessId);

    this.displayedProcessColumns = [
      "#",
      "Application_No",
      "LoanAcNo",
      "Sourced_On",
      "Sourced_By",
      "Completed_ON",
      "BranchName",
      "ProductName",
      "Customer_Name",
      "Current_Process",
      "Loan_Status",
      "EmployeeName",
      "PendingSince",
      "Proposed_loanAmount",
      "Approved_loanAmount",
      "TAT"
    ];

    this.losService.LOS_Sourced_ApplicationStatus_Report_By_PROCESS({
      FromDate: this.FromDate,
      To: this.ToDate,
      LoginUserid: this.currentUser.userId ,
      BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
      ProductId: this.ProductId == "All" ? 0 : this.ProductId,
      ManagerId: this.currentUser.userId,
      ProcessId: item.ProcessID,
    }).subscribe((res: any) => {
      this.showSpinner = false;
      console.log("ProcessId", item.ProcessId);

      if (res.Item2.length > 0) {
        this.dataProcessSource = new MatTableDataSource(res.Item2);
        this.JsonProcessData = res.Item2;
        this.dataProcessSource.sort = this.processSort;
        this.dataProcessSource.paginator = this.processPaginator;

        setTimeout(() => {
          $("#ViewProcessDetail").modal("show");
        }, 0);
      }else {
        this.dataProcessSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
      }
    });

  }
  onCloseProcessDetail() {
    $("#ViewProcessDetail").modal("hide");
  }


  onChangeStatusofProcess() {
    console.log("change of Process Id", this.selectedProcess.ProcessID);

    this.showSpinner = true;

    this.losService.LOS_Sourced_ApplicationStatus_Report_By_PROCESS({
      FromDate: this.FromDate,
      To: this.ToDate,
      LoginUserid: this.currentUser.userId ,
      BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
      ProductId: this.ProductId == "All" ? 0 : this.ProductId,
      
      ManagerId: this.currentUser.userId,
      ProcessId: this.selectedProcess.ProcessID,
      
    }).subscribe((res: any) => {
      if (res.Item2.length > 0) {
        this.dataProcessSource = new MatTableDataSource(res.Item2);
        this.JsonProcessData = res.Item2;
        this.dataProcessSource.sort = this.processSort;
        this.dataProcessSource.paginator = this.processPaginator;

        this.showSpinner = false;
      } else {
        this.dataProcessSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
        this.showSpinner = false;
      }
    });
    this.showSpinner = false;
    // this.DateFrom = "";
    // this.DateTo = "";
    // this.BranchId = 0;
  }
  

  LOS_Sourced_ApplicationStatus_Report_By_Team() {
    this.showSpinner = true;
    this.losService.LOS_Sourced_ApplicationStatus_Report_By_Team({
      FromDate: this.FromDate,
      To: this.ToDate,
      LoginUserid: this.currentUser.userId ,
      BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
      ProductId: this.ProductId == "All" ? 0 : this.ProductId,
      ManagerId: this.currentUser.userId,
      TeamMemberId: "0",
      

    }).subscribe((res: any) => {
      this.teamListData = res.Item1;
      this.showSpinner = false;
    });

  }

  getTeamDetail(teamitem: any) {
      // if (this.selectedTeam?.EmpId === item.EmpId) {
      //   this.selectedTeam = null;
      //   this.dataTeamSource = new MatTableDataSource([]);
      //   this.showTable = false;
      //   return;
      // }
  
      this.showSpinner = true;
      this.selectedTeam = teamitem;
       this.displayedTeamColumns = [
      "#",
      "Application_No",
      "LoanAcNo",
      "Sourced_On",
      "Sourced_By",
      "Completed_ON",
      "BranchName",
      "ProductName",
      "Customer_Name",
      "Current_Process",
      "Loan_Status",
      "EmployeeName",
      "PendingSince",
      "Proposed_loanAmount",
      "Approved_loanAmount",
      "TAT"
    ];
  
      this.losService.LOS_Sourced_ApplicationStatus_Report_By_Team({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserid: this.currentUser.userId ,
        BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
        ProductId: this.ProductId == "All" ? 0 : this.ProductId,
        ManagerId: this.currentUser.userId,
        // TeamMemberId: "0",
        TeamMemberId: teamitem.EmployeeID,
      }).subscribe((res: any) => {
         this.showSpinner = false;
        if (res.Item2.length > 0) {
        this.dataTeamSource = new MatTableDataSource(res.Item2);
        this.JsonDataTeam = res.Item2;
        this.dataTeamSource.sort = this.teamSort;
        this.dataTeamSource.paginator = this.teamPaginator;

        setTimeout(() => {
          $("#ViewTeamDetail").modal("show");
        }, 0);
      }else {
        this.dataProcessSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
        this.showSpinner = false;

      }
        
      });
      // this.DateFrom = "";
      // this.DateTo = "";
      // this.BranchId = 0;
    }
     onCloseTeamDetail() {
    $("#ViewTeamDetail").modal("hide");
  }

  
    onChangeTeamDetail() {

      this.showSpinner = true;
      this.losService.LOS_Sourced_ApplicationStatus_Report_By_Team({
        FromDate: this.FromDate,
        To: this.ToDate,
        LoginUserid: this.currentUser.userId ,
        BranchId: this.SelectBranch == "All" ? 0 : this.SelectBranch,
        ProductId: this.ProductId == "All" ? 0 : this.ProductId,
        ManagerId: this.currentUser.userId,
        TeamMemberId: this.selectedTeam.EmployeeID,
        
      }).subscribe((res: any) => {
         if (res.Item2.length > 0) {
        this.dataTeamSource = new MatTableDataSource(res.Item2);
        this.JsonDataTeam = res.Item2;
        this.dataTeamSource.sort = this.teamSort;
        this.dataTeamSource.paginator = this.teamPaginator;

        setTimeout(() => {
          $("#ViewTeamDetail").modal("show");
        }, 0);
      }else {
        this.dataProcessSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: "No Data Found",
          ...this.configSuccess,
        });
        this.showSpinner = false;

      }
        
      });
      // this.DateFrom = "";
      // this.DateTo = "";
      // this.BranchId = 0;
    }
  

  onCloseTATReportModel() {
      $("#ViewTATReportModel").modal("hide");
  }
  
  GoToTATReportDetail(row) {
      console.log("row" + row);

      //this.showSpinner = true;
      this.displayedDetailColumns = [
          "ProcessId",
        "Process",
        "ProcessExecutive",
        "ProcessStatus",
        "AssignedOn",
        "CompletedOn",
        "TAT_Hr",
        "Maximum_Standard_Tat",
        "TAT_Status",
        "Remark",
        "LatLong",
      ];

      this.dataSourceDetail = new MatTableDataSource([]);
      this.dataSourceDetail.sort = this.sort;
      this._QuickLoanService
      .Quick_rpt_TAT_Report({ LoanId: row.Loan_Id })
      .subscribe((res) => {
        console.log("result: ", res);

        $("#ViewTATReportModel").modal("show");
        $("#ViewTATReportModel").css("z-index", "1050");

        this.TatReportsList = JSON.parse(JSON.stringify(res));
        this.Application_No =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].Application_No
                : ""
              : ""
            : "";
        this.CustomerInfo =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].Customer
                : ""
              : ""
            : "";
        this.Product =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].Product
                : ""
              : ""
            : "";
        this.Branch =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].Branch
                : ""
              : ""
            : "";
        this.ApplicationCreatedOn =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].ApplicationCreatedOn
                : ""
              : ""
            : "";
        this.LoanAmount =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].LoanAmount
                : ""
              : ""
            : "";
        this.LoanDuration_Month =
          Object.keys(this.TatReportsList).length > 0
            ? this.TatReportsList.Item1
              ? this.TatReportsList.Item1[0]
                ? this.TatReportsList.Item1[0].LoanDuration_Month
                : ""
              : ""
            : "";

        if (!!!this.LoanAmount) this.LoanAmount = 0;
        this.JsonData = this.TatReportsList.Item2;
        this.dataSourceDetail = new MatTableDataSource(
          this.TatReportsList.Item2
        );
        this.dataSourceDetail.sort = this.sort;
        //this.dataSourceDetail.paginator = this.paginator;
        this.showSpinner = false;

        let sum = 0;
        let pending = this.TatReportsList.Item2.find((obj: any) => {
          return !obj.CompletedOn;
        }).TAT_Hr;
        for (let i = 0; i < this.TatReportsList.Item2.length; i++) {
          if (this.TatReportsList.Item2[i].CompletedOn)
            sum += Number(this.TatReportsList.Item2[i].TAT_Hr);
          if (
            !this.TatReportsList.Item2[i].CompletedOn &&
            Number(pending) < Number(this.TatReportsList.Item2[i].TAT_Hr)
          )
            pending = this.TatReportsList.Item2[i].TAT_Hr;
        }
        this.ProcessComplition = sum.toFixed(2);
        this.PendingSince = pending;

        console.log(" sum.toFixed(2)", sum.toFixed(2));
        var days: number = this.ProcessComplition / 24;
        console.log("days.toFixed(0)", Math.floor(days));
        var hour = (days - Math.floor(days)) * 24;
        if (hour) {
          this.ProcessComplition =
            Math.floor(days) + "d " + hour.toFixed(2) + "h";
        } else {
          this.ProcessComplition = Math.floor(days) + "d";
        }

        var days1: number = this.PendingSince / 24;
        var hour1 = (days1 - Math.floor(days1)) * 24;
        if (hour1) {
          this.PendingSince = Math.floor(days1) + "d " + hour1.toFixed(2) + "h";
        } else {
          this.PendingSince = Math.floor(days1) + "d";
        }

        this.dataSourceDetail = new MatTableDataSource(
          this.TatReportsList.Item2
        );
        this.dataSourceDetail.sort = this.sort;
        console.log(this.dataSourceDetail.data as Array<Object>);
        var min = this.dataSource.data[0].AssignedOn;
        //if Application Generation completed is null then TAT is Current
        var max = !!this.dataSourceDetail.data[0].CompletedOn
          ? this.dataSourceDetail.data[0].CompletedOn
          : Date();
        for (let x of this.dataSourceDetail.data) {
          if (!!x.AssignedOn) {
            min = min < x.AssignedOn ? min : x.AssignedOn;
            if (!!x.CompletedOn)
              max = max > x.CompletedOn ? max : x.CompletedOn;
          }
        }
        console.log("max: " + max);
        console.log("min: " + min);
        console.log(this.convertStringToDate(max));

        this.showSpinner = false;
      });
    }
  getTotalMaximumStandardTat(): number {
  // Sums up the Maximum_Standard_Tat from TatReportsList.Item2 if available
    if (
      this.TatReportsList &&
      this.TatReportsList.Item2 &&
      Array.isArray(this.TatReportsList.Item2)
    ) {
      return this.TatReportsList.Item2.reduce(
        (sum: number, item: any) =>
          sum + (Number(item.Maximum_Standard_Tat) || 0),
        0
      );
    }
    return 0;
  }

  getTotalMaximumStandardTatFormatted(): string {
    const totalHours = this.getTotalMaximumStandardTat();
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    let result = '';
    if (days > 0) {
      result += `${days}d `;
    }
    result += `${hours}h`;
    return result.trim();
  }
  convertStringToDate(str: string) {
    var array = str.substring(0, 10);
    console.log("Array" + array);
    return new Date(array);
  }
  getPendingMaximumStandardTat(): number {
  // Sums up the Maximum_Standard_Tat from TatReportsList.Item2 for pending items (where CompletedOn is falsy)
    if (
      this.TatReportsList &&
      this.TatReportsList.Item2 &&
      Array.isArray(this.TatReportsList.Item2)
    ) {
      return this.TatReportsList.Item2
        .filter((item: any) => !item.CompletedOn)
        .reduce(
          (sum: number, item: any) =>
            sum + (Number(item.Maximum_Standard_Tat) || 0),
          0
        );
    }
    return 0;
  }
  getPendingMaximumStandardTatFormatted(): string {
    const totalHours = this.getPendingMaximumStandardTat();
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    let result = '';
    if (days > 0) {
      result += `${days}d `;
    }
    result += `${hours}h`;
    return result.trim();
  }
  parseDaysHoursToHours(str: string): number {
    // Expects format like "2d 5h" or "5h" or "2d"
    let days = 0, hours = 0;
    if (!str) return 0;
    const dayMatch = str.match(/(\d+)d/);
    const hourMatch = str.match(/(\d+)h/);
    if (dayMatch) days = parseInt(dayMatch[1], 10);
    if (hourMatch) hours = parseInt(hourMatch[1], 10);
    return days * 24 + hours;
  }
  isProcessDelayed(): boolean {
  return (
    this.parseDaysHoursToHours(this.ProcessComplition) >
    this.parseDaysHoursToHours(this.getTotalMaximumStandardTatFormatted())
  );
  }

  isPendingDelayed(): boolean {
    return (
      this.parseDaysHoursToHours(this.PendingSince) >
      this.parseDaysHoursToHours(this.getPendingMaximumStandardTatFormatted())
    );
  }
  exportOverallTable() {
  this.overallExporter.exportTable('xlsx', { fileName: 'Overall_Report' });
  }

  // 2. Shared export for Process / Team
  exportDetailTable(exporter: any, name: any, type: 'Process' | 'Team') {
  // if name is an object, extract correct field
  let displayName: string;

  if (typeof name === 'string') {
    displayName = name;
  } else if (type === 'Process' && name?.ProcessName) {
    displayName = name.ProcessName;
  } else if (type === 'Team' && name?.EmployeeName) {
    displayName = name.EmployeeName;
  } else {
    displayName = type; // fallback
  }

  const safeName = displayName.replace(/\s+/g, '_');
  exporter.exportTable('xlsx', { fileName: `${type}_${safeName}_Report` });
}
  

}
